import React from 'react'

const WeaviateIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#00C691"/>
    <path d="M12 3L20.5 8.5V15.5L12 21L3.5 15.5V8.5L12 3Z" fill="white" fillOpacity="0.12"/>
    <path d="M12 3L20.5 8.5L12 12L3.5 8.5L12 3Z" fill="white" fillOpacity="0.6"/>
    <path d="M3.5 8.5L12 12V21L3.5 15.5V8.5Z" fill="white" fillOpacity="0.85"/>
    <path d="M20.5 8.5L12 12V21L20.5 15.5V8.5Z" fill="white"/>
    <path d="M12 3L20.5 8.5L12 12L3.5 8.5L12 3Z" stroke="white" strokeOpacity="0.3" strokeWidth="0.4"/>
    <path d="M3.5 8.5L12 12V21" stroke="white" strokeOpacity="0.3" strokeWidth="0.4"/>
    <path d="M20.5 8.5L12 12V21" stroke="white" strokeOpacity="0.3" strokeWidth="0.4"/>
  </svg>
)

export default WeaviateIcon
